import { gsap } from "gsap";

export default class Forms {
    constructor() {
        this.initFloatingLabels();
    }

    initFloatingLabels() {
        const inputs = document.querySelectorAll(".gform_wrapper .floating-label input, .gform_wrapper .floating-label textarea");

        if (!inputs.length) return;

        inputs.forEach((input) => {
            const floatingLabel = input.closest(".floating-label");
            const label = floatingLabel?.querySelector("label");

            if (!floatingLabel || !label) return;

            gsap.set(label, { y: "10px" });

            const toggleActiveClass = () => {
                if (input.value.trim() || document.activeElement === input) {
                    floatingLabel.classList.add("active");
                    gsap.to( label, {
                        y: "-25px",
                        duration: 0.3,
                        ease: "power2.out"
                    });
                } else {
                    floatingLabel.classList.remove("active");
                    gsap.to( label, {
                        y: "10px",
                        duration: 0.3,
                        ease: "power2.out"
                    });
                }
            };

            input.addEventListener("focus", toggleActiveClass);
            input.addEventListener("input", toggleActiveClass);
            input.addEventListener("blur", toggleActiveClass);

            toggleActiveClass();
        });
    }
}
